import React from 'react';

// Inputs are inline-block by default and keep their intrinsic `size` width,
// which collapses them inside flex rows — always fill the slot they are given.
export function Input({ className = '', ...props }) {
  return <input className={`w-full ${className}`} {...props} />;
}
